import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, Renderer2, Signal, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { TableQuestionComponent } from './components/table-question/table-question.component';
import { RangeQuestionComponent } from './components/range-question/range-question.component';
import { NumberQuestionComponent } from './components/number-question/number-question.component';
import { MarkQuestionComponent } from './components/mark-question/mark-question.component';
import { FreeTextQuestionComponent } from './components/free-text-question/free-text-question.component';
import { NgSwitch } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CdkDrag, CdkDragDrop, CdkDragPlaceholder, DragDropModule } from '@angular/cdk/drag-drop';
import { Question } from 'src/app/models/question.model';
import { EQuestionType } from 'src/app/models/questionType.model';
import { FillQuestionComponent } from './components/fill-question/fill-question.component';
import { DividerLineComponent } from './components/divider-line/divider-line.component';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { EStatus } from 'src/app/models/EnumStatus';
import { TextToQuestionComponent } from './components/text-to-question/text-to-question.component';
import { LinkComponent } from './components/link/link.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { DragStore } from 'src/app/store/drag-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QuestionsGroupComponent } from './components/questions-group/questions-group.component';
import { SignatureComponent } from './components/signature/signature.component';
import { RichTextComponent } from 'src/app/shared/components/rich-text/rich-text.component';
import { CollectionQuestionApiService } from 'src/app/features/collections/services/collection-question-api.service';
import { ImageComponent } from './components/image/image.component';
import { PhoneNumberQuestionDisplayComponent } from '../question-form-display/components/phone-number-question-display/phone-number-question-display.component';
import { FillQuestionDisplayComponent } from '../question-form-display/components/fill-question-display/fill-question-display.component';
import { SignatureDisplayComponent } from '../question-form-display/components/signature-display/signature-display.component';
import { UploadFileAdminComponent } from './components/upload-file-admin/upload-file-admin.component';
import { DateQuestionDisplayComponent } from '../question-form-display/components/date-question-display/date-question-display.component';
import { DateQuestionComponent } from './components/date-question/date-question.component';
import { ExpenseComponent } from './components/expense/expense.component';

@Component({
    selector: 'que-question-form',
    imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TableQuestionComponent,
        RangeQuestionComponent,
        NumberQuestionComponent,
        MarkQuestionComponent,
        FreeTextQuestionComponent,
        FillQuestionComponent,
        DividerLineComponent,
        TextToQuestionComponent,
        UploadFileComponent,
        NgSwitch,
        MatInputModule,
        FormsModule,
        CdkDragPlaceholder,
        CdkDrag,
        DragDropModule,
        LinkComponent,
        QuestionsGroupComponent,
        SignatureComponent,
        MatFormFieldModule,
        RichTextComponent,
        TranslateDirective, TranslatePipe,
        ImageComponent,
        PhoneNumberQuestionDisplayComponent,
        DateQuestionDisplayComponent,
        FillQuestionDisplayComponent,
        SignatureDisplayComponent,
        UploadFileAdminComponent,
        DateQuestionComponent,
        ExpenseComponent
    ],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: QuestionFormComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: QuestionFormComponent,
            multi: true
        }
    ],
    templateUrl: './question-form.component.html',
    styleUrls: ['./question-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionFormComponent implements OnInit, ControlValueAccessor, Validator {
  @ViewChild('questionForm') mydiv: ElementRef | undefined;

  @Input() question?: Question | null;//מיותר?!!
  @Input() index: number = -4;
  @Output() myDropEvevt: EventEmitter<CdkDragDrop<string[]>> = new EventEmitter();

  eQuestionType = EQuestionType;
  #store = inject(QuestionnaireStore);
  #dragStore = inject(DragStore)
  #collectionApiService = inject(CollectionQuestionApiService);
  questionForm2 = new FormControl<Question | null>(null, [Validators.required]);

  focusId$ = this.#dragStore.focusId$;

  // myIndex = new BehaviorSubject<number>(-4);
  // myIndex$ = this.myIndex.asObservable();
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  questionStatus?: EStatus;
  isDragEvent$ = this.#dragStore.isDrag$

  ngOnInit(): void {
    this.questionForm2.valueChanges.subscribe(question => {
      if (this.questionStatus == EStatus.Saved)
        this.questionStatus = EStatus.Changed;
      this.registerOnChangeCallback({ ...question, status: this.questionStatus, isFocus: false } as Question);
    });
  }
  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm2.valid) {
      return null;
    }
    return { 'stepForm': "not-valid" }
  }
  writeValue(obj: Question): void {
    this.questionStatus = obj.status;
    this.questionForm2.patchValue({ ...obj }, { emitEvent: false });
    // //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  save() {
  }
  startDrag() {
    this.#dragStore.updatDragEvent(true);
    if (this.index !== undefined)
      this.#dragStore.updatSortId(this.index);
  }
  dragEnter() {
  }
  drop(event: any) {
    this.myDropEvevt.emit(event)
  }

  // focus(ev: boolean) {
  //   if (ev) {
  //     this.#dragStore.updatFocusId(this.index)
  //   }
  //   else {
  //     this.#dragStore.updatFocusId(-4)
  //   }
  // }
}
